import { Tabs, type TabsProps } from 'antd';

export const AppTabs = ({ children, ...props }: TabsProps) => {
  return (
    <Tabs {...props} destroyInactiveTabPane>
      {children}
    </Tabs>
  );
};

AppTabs.TabPane = Tabs.TabPane;
